import React from 'react';

import GrantDetailPage from '../components/GrantDetailPage';

const GrantDetailApp = (props) => (
  <GrantDetailPage {...props} />
);

export default GrantDetailApp;
